module.exports = __webpack_public_path__ + "static/media/SERVICE_DOG_MATERIAL.a9be1e1c.svg";